import { render, staticRenderFns } from "./RemoveComplete.vue?vue&type=template&id=68197168&"
import script from "./RemoveComplete.vue?vue&type=script&lang=js&"
export * from "./RemoveComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports